import { changeType,  getContainerTypeEvalResults } from "../helpers/ResultsHelpers"


type ResultsEvaluatorsProps ={
  info:any
  typeEvalExt:number
  lastItem:boolean
}

const ResultsEvaluators = ({info,typeEvalExt,lastItem}:ResultsEvaluatorsProps) => {

  const returnPesoByType=(typeEval:string)=>{
    switch (typeEval) {
      case 'autoevaluacion':
         return info.pesoAuto
      case 'lider':
         return info.pesoLider             
      case 'colega':
         return info.pesoColega             
      case 'subordinado':
         return info.pesoSubordinado             
      case 'cliente':
         return info.pesoCliente           
    }
  }

  const ptc=((info.sum * 100 )/ (info.count*5)).toFixed(2)

   return (
    <>
     <div className={getContainerTypeEvalResults(typeEvalExt)} style={{borderRight: lastItem === true ? 'none' : '' }}>
       <div className="containerTxtEvalRes"> <span className="contTypeEvalRes">{changeType(info.typeEval)}</span> </div>
        <div className="containerPuntRes">
            <div><span className="titleResEval">Puntuación</span></div>
            <div><span className="desResEval">{Number(ptc)>100 ? 100:ptc }</span></div> 
        </div>
        <div className="containerPesoRes">
          <div><span className="titleResEval">Peso</span></div>
          <div><span className="desResEval">{returnPesoByType(info.typeEval)}%</span></div>
        </div> 
     </div>
     
    </>
  )
}

export default ResultsEvaluators
